exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._38F8ReC0h3Z3pcJBkbQBl5{height:52px;width:44px}._38F8ReC0h3Z3pcJBkbQBl5:hover{color:\"[theme:themeDarker, default:#004578]\"}html[dir] ._38F8ReC0h3Z3pcJBkbQBl5:hover{background:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"personaSuggestionIconButton": "_38F8ReC0h3Z3pcJBkbQBl5"
};